import { useState } from "react";

import { ResponseTheme } from "~/providers/utils/types/patientPreviewTypes";
import { PreviewSectionLayout } from "../common/PreviewSectionLayout";
import { ResponseThemesModal } from "./ResponseThemesModal";
import { ResponseThemesTable } from "./ResponseThemesTable";
import { ResponseThemesTitle } from "./ResponseThemesTitle";

export const ResponseThemes = ({
  responseThemes,
}: {
  responseThemes: ResponseTheme[];
}) => {
  const [showInfoModal, setShowInfoModal] = useState<boolean>(false);

  return (
    <PreviewSectionLayout
      title={<ResponseThemesTitle onClick={() => setShowInfoModal(true)} />}
    >
      <ResponseThemesTable responseThemes={responseThemes} filtered />

      <ResponseThemesModal
        responseThemes={responseThemes}
        show={showInfoModal}
        onClose={() => setShowInfoModal(false)}
      />
    </PreviewSectionLayout>
  );
};
